module.exports = __webpack_public_path__ + "img/app.6adcccb6.svg";